<template>
  <v-dialog
    class='csp-filter-popup'
    :value="visiblePopup"
    :max-width="400"
    @click:outside="onNoClickButton()"
    @keydown.esc="onNoClickButton()"
  >
    <v-card class="popup-wrapper">
      <div class="title">{{$t(title)}}</div>
      <div class='csp-wrapper'>
        <v-chip-group
          active-class='primary--text'
          column
          multiple
          :key="visiblePopup"
        >
          <v-chip
            v-for="(csp, index) in cspOptions"
            :key="index"
            @click='addChip(csp)'
            class='csp'
            :class="csp"
          >
            <v-img class='csp__icon' :src='subdomainSaasPlatformsIcons[csp.toLowerCase()]'/>
            {{ csp }}
          </v-chip>
        </v-chip-group>
      </div>
      <div class="buttons">
        <v-btn v-if='showNoButton' small depressed class="no-button btn-secondary" @click="onNoClickButton()">
          {{$t(noCaption)}}
        </v-btn>
        <v-btn small depressed class="yes-button btn-primary" @click="onYesClickButton()" :disabled='saveDisabled'>
          {{$t(yesCaption)}}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>

</template>

<script>
import { CONFIGURATION } from '@/constants/configuration';
import disableOuterScrollOnPopupVisible from '@/mixins/disableOuterScrollOnPopupVisible';
import AwsIcon from '@/assets/aws.svg';
import GcpIcon from '@/assets/gcp.svg';
import AzureIcon from '@/assets/azure.svg';

export default {
  name: 'SelectCSPFilterPopup',
  mixins: [disableOuterScrollOnPopupVisible],
  props: {
    title: String,
    yesCaption: String,
    noCaption: String,
    showNoButton: {
      type: Boolean,
      default: true,
      required: false,
    },
    visiblePopup: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      selectedCSP: [],
    };
  },
  methods: {
    onYesClickButton() {
      this.$emit('clicked', this.selectedCSP);
      this.selectedCSP = [];
    },
    onNoClickButton() {
      this.$emit('clicked', false);
      this.selectedCSP = [];
    },
    addChip(csp) {
      if (this.selectedCSP.includes(csp)) {
        this.selectedCSP = this.selectedCSP.filter(item => item !== csp);
      } else {
        this.selectedCSP.push(csp);
      }
    },
  },
  computed: {
    cspOptions() {
      return Object.values(CONFIGURATION.SOURCE_TYPE).map(option => {
        if (option === CONFIGURATION.SOURCE_TYPE.azure) {
          return option.charAt(0).toUpperCase() + option.slice(1);
        }
        return option.toUpperCase();
      });
    },
    subdomainSaasPlatformsIcons() {
      return {
        aws: AwsIcon,
        gcp: GcpIcon,
        azure: AzureIcon,
      };
    },
    saveDisabled() {
      return this.selectedCSP.length === 0;
    },
  },
};
</script>

<style lang='scss'>
@import '~@/assets/styles/design-system';

.csp-wrapper {
  .v-slide-group__wrapper.v-slide-group__wrapper {
    padding-left: $space-8;
  }
}
</style>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.popup-wrapper {
  max-width: rem(400);
  min-width: rem(400);
  padding: $space-8 $space-10;

  .csp-wrapper {
    min-width: rem(400);
    margin-left: -11%;
    margin-bottom: rem(-20);

    .csp {
      margin-bottom: $space-1-5;
      color: var(--text-secondary);
      background-color: var(--bg-tertiary);

      &__icon {
        width: rem(25);
        margin-right: rem(5);
      }
    }
  }

  .title {
    color: var(--text-primary);
    font-size: $font-size-base;
    font-weight: 600;
    letter-spacing: 1.12px;
    line-height: $space-4;
    text-transform: uppercase;
    padding-bottom: $space-6;
  }

  .buttons {
    text-align: right;
    padding-top: $space-7;

    .no-button {
      box-sizing: border-box;
      height: $btn-height-md;
      width: rem(86);
      border: $border-width-thin solid var(--brand-primary);
      color: var(--brand-primary);
      border-radius: $radius-sm;
      background-color: var(--bg-primary);
      box-shadow: $shadow-sm;
    }

    .yes-button {
      height: $btn-height-md;
      width: rem(51);
      border-radius: $radius-sm;
      box-shadow: $shadow-sm;
      font-size: $font-size-sm;
      font-weight: 500;
      letter-spacing: 1.07px;
      line-height: $space-4;
      text-align: center;
      margin-left: $space-2;
    }
  }
}
</style>
